import {jsonArrayMember, jsonMember, jsonObject} from "typedjson";


@jsonObject
export class DxListMessageOptions {
  @jsonArrayMember(String, {name: "title", emitDefaultValue: false, isRequired: false})
  private _title: string[];

  @jsonArrayMember(String, {name: "subtitle", emitDefaultValue: false, isRequired: false})
  private _subtitle: string[];

  @jsonMember({name: "icon", constructor: String, emitDefaultValue: false, isRequired: false})
  private _icon: string;

  @jsonMember({name: "showMessageLink", constructor: Boolean, emitDefaultValue: false, isRequired: false })
  private _showMessageLink: boolean = false;

  @jsonMember({name: "messageLinkTitle", constructor: String, emitDefaultValue: false, isRequired: false })
  private _messageLinkTitle: string;

  get title(): string[] {
    return this._title;
  }

  set title(value: string[]) {
    this._title = value;
  }

  get subtitle(): string[] {
    return this._subtitle;
  }

  set subtitle(value: string[]) {
    this._subtitle = value;
  }

  get icon(): string {
    return this._icon;
  }

  set icon(value: string) {
    this._icon = value;
  }

  get showMessageLink(): boolean {
    return this._showMessageLink;
  }

  set showMessageLink(value: boolean) {
    this._showMessageLink = value;
  }

  get messageLinkTitle(): string {
    return this._messageLinkTitle;
  }

  set messageLinkTitle(value: string) {
    this._messageLinkTitle = value;
  }
}
